import React from 'react';
import { motion } from 'framer-motion';

const SectionIndicator = ({ navItems, activeSection }) => {
  return (
    <div className="md:hidden">
      <div className="flex items-center justify-center gap-1.5 py-2.5 px-4 border-b border-white/[0.03]">
        {navItems.map((item) => (
          <motion.div
            key={item.id}
            animate={{
              width: activeSection === item.id ? 20 : 3,
              opacity: activeSection === item.id ? 1 : 0.25
            }}
            transition={{
              type: "spring",
              stiffness: 400,
              damping: 28
            }}
            className={`h-[2px] transition-all duration-300 ${
              activeSection === item.id
                ? 'bg-gradient-to-r from-emerald-500/70 to-violet-500/70 rounded-full'
                : 'bg-white/15 rounded-full'
            }`}
          />
        ))}
      </div>
    </div>
  );
};

export default SectionIndicator;